import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import Spinner from '@/components/Spinner'

/**
 * ProtectedRoute – Schützt verschachtelte Routes.
 * Leitet auf /portal/login um wenn nicht eingeloggt.
 */
export default function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Spinner />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/portal/login" state={{ from: location }} replace />
  }

  return <Outlet />
}

/**
 * AdminRoute – Erlaubt nur Zugriff für Admins.
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAdmin, isLoading } = useAuth()

  if (isLoading) return <Spinner className="mt-20" />

  if (!isAdmin) {
    return (
      <div className="px-6 py-20 text-center">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Zugriff verweigert</h2>
        <p className="text-gray-500">Nur Administratoren haben Zugang zu diesem Bereich.</p>
      </div>
    )
  }

  return <>{children}</>
}

/**
 * SuperAdminRoute – Erlaubt nur Zugriff für Superadmins.
 */
export function SuperAdminRoute({ children }: { children: React.ReactNode }) {
  const { isSuperAdmin, isLoading } = useAuth()

  if (isLoading) return <Spinner className="mt-20" />

  if (!isSuperAdmin) {
    return (
      <div className="px-6 py-20 text-center">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Zugriff verweigert</h2>
        <p className="text-gray-500">Nur Superadmins haben Zugang zu diesem Bereich.</p>
      </div>
    )
  }

  return <>{children}</>
}
